import { FC } from 'react'
import { ReactComponent as IconCheck } from 'assets/faCheck.svg'

type Props = {
  isChecked: boolean
  onChange: (v: boolean) => void
  isError: boolean
  title: string
}

const ConfirmationCheckbox: FC<Props> = ({
  onChange,
  isChecked,
  isError,
  title
}) => {
  const textColor = isError ? 'text-red-500' : 'text-gray-400'
  return (
    <div
      className='flex flex-row w-full pt-[30px] px-4 items-center cursor-pointer'
      onClick={() => onChange(!isChecked)}
    >
      <div className='w-5 h-5 rounded-[4px] border border-gray-500 shrink-0 flex items-center justify-center text-teal-500'>
        {isChecked && <IconCheck />}
      </div>
      <div className='pl-2 text-xs'>
        <span className={textColor}>{title}</span>
      </div>
    </div>
  )
}

export default ConfirmationCheckbox
